const siteConfig = {
  defaultImagePath: 'DefaultArticleThumbnail.jpg',
  domain: 'https://groups.coca-cola.com',
  baseSitePath: '/sites/NAOUQSE',
  vivaCommunity: {
    communityLinkPrefix: 'https://engage.cloud.microsoft/main/org/coca-cola.com/groups/'
  }
}

export default siteConfig